"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var budgetLinesList_1 = require("common/global/budgetLinesList");
var categoriesList_1 = require("common/global/categoriesList");
var currenciesList_1 = require("common/global/currenciesList");
var donorsList_1 = require("common/global/donorsList");
var officesList_1 = require("common/global/officesList");
var projectsList_1 = require("common/global/projectsList");
var unitsList_1 = require("common/global/unitsList");
var usersList_1 = require("common/global/usersList");
var warehousesList_1 = require("common/global/warehousesList");
var react_1 = __importStar(require("react"));
var useIntervalDynamic_1 = __importDefault(require("../hooks/useIntervalDynamic"));
var reduxHooks_1 = require("portal/hooks/reduxHooks");
var warehouseRolesList_1 = require("common/global/warehouseRolesList");
var userProjectRolesList_1 = require("common/global/userProjectRolesList");
var LoadGlobal = function (_a) {
    var children = _a.children;
    var currentUser = (0, reduxHooks_1.useAppSelector)(function (state) { return state.auth; }).currentUser;
    var _b = (0, react_1.useState)(false), loaded = _b[0], setLoaded = _b[1];
    (0, useIntervalDynamic_1.default)(function () {
        setLoaded(!!(budgetLinesList_1.globalBudgetLinesData &&
            categoriesList_1.globalCategoriesData &&
            currenciesList_1.globalCurrenciesData &&
            donorsList_1.globalDonorsData &&
            officesList_1.globalOfficesData &&
            projectsList_1.globalProjectsData &&
            unitsList_1.globalUnitsData &&
            usersList_1.globalUsersData &&
            warehousesList_1.globalWarehousesData &&
            warehouseRolesList_1.globalUserWarehouseRolesData &&
            userProjectRolesList_1.globalUserProjectRolesData &&
            currentUser.permissions));
    }, 200);
    if (!loaded) {
        return (0, jsx_runtime_1.jsx)(antd_1.Spin, {});
    }
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children });
};
exports.default = LoadGlobal;
